import { useEffect, useRef } from "react";

export default function ScanCanvas({ className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    let w, h, raf;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const mouse = { x: 0.5, y: 0.5, tx: 0.5, ty: 0.5 };

    const resize = () => {
      w = canvas.width = canvas.offsetWidth * dpr;
      h = canvas.height = canvas.offsetHeight * dpr;
    };
    resize();
    window.addEventListener("resize", resize);

    const onMove = (e) => {
      const r = canvas.getBoundingClientRect();
      mouse.tx = (e.clientX - r.left) / r.width;
      mouse.ty = (e.clientY - r.top) / r.height;
    };
    window.addEventListener("mousemove", onMove);

    let t = 0;
    const cols = 46;
    const rows = 24;

    const draw = () => {
      t += 0.012;
      mouse.x += (mouse.tx - mouse.x) * 0.04;
      mouse.y += (mouse.ty - mouse.y) * 0.04;
      ctx.clearRect(0, 0, w, h);

      const ox = (0.5 - mouse.x) * w * 0.05;
      const oy = (0.5 - mouse.y) * h * 0.05;
      const scanCol = (t * 14) % (cols * 1.7) - cols * 0.2;

      for (let i = 0; i <= cols; i++) {
        for (let j = 0; j <= rows; j++) {
          const wave = Math.sin(i * 0.42 + t * 1.5) * Math.cos(j * 0.38 - t * 0.9);
          const px = (i / cols) * w + ox;
          const py = (j / rows) * h + wave * 9 * dpr + oy;
          const dist = Math.abs(scanCol - i);
          const near = Math.max(0, 1 - dist / 7);
          if (near > 0.08) {
            ctx.fillStyle = `rgba(255, 90, 0, ${0.12 + near * 0.55})`;
            const s = (1.4 + near * 1.6) * dpr;
            ctx.fillRect(px, py, s, s);
          } else {
            ctx.fillStyle = "rgba(255, 255, 255, 0.055)";
            ctx.fillRect(px, py, 1.1 * dpr, 1.1 * dpr);
          }
        }
      }
      raf = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return <canvas ref={ref} className={className} aria-hidden="true" />;
}
